import React from 'react';
import styled from 'styled-components';
import {withRouter} from 'react-router-dom';

import { Row, Col, Button, DropdownItem } from 'reactstrap';

import  styledMagstimTableWrapper from 'common/controls/StyledMagstimTableWrapper'

import {
    MagstimHeaderBar,
    MagstimTableDiagnoses, 
    CurrentLang,
    LocaliseRatingScale,
    MagstimFetch, 
    MagstimLoadingSpinner, 
    magstim_clickHandler, 
    isPDA, 
    CurrentTheme, 
    GetRange, 
    MagstimDropdown,
    MagstimColor
} from "common";

import { REST_DIAGNOSIS } from 'common/ApiEndpoints';
import * as CsvUtils from 'common/utils/CsvUtils';

const EXPORT_FILE_NAME = 'diagnoses.csv'
const DATE_FILTER = 'CreatedTime'

class Diagnoses extends React.Component {

    state = {
        isLoading:true,
        tableHeight: 'calc(100vh - 340px)',
        exportFileName:EXPORT_FILE_NAME
    };
    
    constructor() {
        super();

        this._table = React.createRef();    
    }
    
    // eslint-disable-next-line no-unused-vars
	onClickExport = (event) => {
		// console.log('onClickExport');

		if(isPDA()){
			CsvUtils.downloadAsCSV(document, this.state.exportFileName, this._table.current.getColumns(), this._table.current.getFilteredData());
		}
    }

    onSelectDate = (id) => {
		const range = GetRange(id);
		this._table.current.addFilter(DATE_FILTER, range);
    }
    
    render() {

        var users = <div className="ml-3 mr-3" >
            <Row className="ui-header ">
        
                    <Col md="6" sm="12" className="header-col">
                         <MagstimHeaderBar main_title={CurrentLang().edit_patient_diagnosis} ShowClose={false}  main_icon="fas fa-stethoscope">
                        </MagstimHeaderBar>
                    </Col>
                 
                        <Col  md={{ offset: 3, size: 3 }} sm="12" className="mt-auto mb-auto">
                            {<MagstimDropdown id="treatmentDate" ref={this._dateFilter} onSelect={this.onSelectDate} icon='fas fa-calendar-alt'>
                                <DropdownItem key="allTime" id='allTime' active>{CurrentLang().treatment_history_date_allTime}</DropdownItem>
                                <DropdownItem key="divider" divider />
                                <DropdownItem key="lastWeeks4" id='lastWeeks4'>{CurrentLang().treatment_history_date_lastWeeks4}</DropdownItem>
                                <DropdownItem key="lastMonths6" id='lastMonths6'>{CurrentLang().treatment_history_date_lastMonths6}</DropdownItem>
                                <DropdownItem key="lastMonths12" id='lastMonths12'>{CurrentLang().treatment_history_date_lastMonths12}</DropdownItem>
                            </MagstimDropdown>}
                        </Col>
    
            </Row>
            <Row className="ui-bg">
                <Col>           
                    <div className="table-area mt-0">
                        <MagstimLoadingSpinner isLoading={this.state.isLoading}/>
                        <MagstimTableDiagnoses ref={this._table} div_name="idDiagnoses"  cellClickCallback={this.cellClickCallback} ></MagstimTableDiagnoses>
                    </div>
                </Col>
            </Row>
            <Row className="ui-bg">
                <Col className="pt-1 pr-4 mt-3 mr-3 mb-3 text-right">
                    <Button color="primary" disabled={this.state.exportDisabled} className="pl-5 pr-5" onClick={this.onClickExport} size={CurrentTheme().ControlSize} ><i className="fas fa-file-excel pr-2"></i> {CurrentLang().table_export_title}</Button>
                </Col>
            </Row>
            </div>;

        return (
            <Wrapper className="ml-3 mr-3" tableHeight={this.state.tableHeight}>    
                {users}            
            </Wrapper>
        )
    }

    componentDidMount() {
        this.loadDataFromAPI();
    }

    componentWillUnmount(){
        this.props.setCurrentPatientID("");
    }

    loadDataFromAPI(){
		MagstimFetch.get(`${REST_DIAGNOSIS}/${this.props.match.params.PatientGuid}`)
		.then((data) => {

            LocaliseRatingScale(data.AllRatingScale);


            data.items.forEach(element => { if(element.CodeTypeIcd10 === undefined || element.CodeTypeIcd10 === null){
                element.CodeTypeIcd10 = CurrentLang().no_data;
            } });

            this.init(data.items);
            
            if ((undefined !== data.patientDetail) && (null !== data.patientDetail)){
				var userNameAndID = `${data.patientDetail.FirstName} ${data.patientDetail.LastName} - ${data.patientDetail.PatientIdNum}`;
				this.setState({exportFileName: `${userNameAndID}-${EXPORT_FILE_NAME}`})
				this.props.setCurrentPatientID(userNameAndID);
			}
		})
		.catch((error) => {
            this.handleError(error);
		}).finally(() => {
			this.setState({isLoading:false});
		});
	}
       
    init(data) {
        if(this._table && this._table.current){
            this._table.current.initForSelect(data);
            this._table.current.resetFilters();
        }
    }
    
    handleError(error){
		console.log(error);
		if(this.props.handleError !== undefined){
			this.props.handleError(error);
		}

		if(isPDA() === false){
			magstim_clickHandler('error', error);
		}
	}
}

const Wrapper = styled(styledMagstimTableWrapper)`

.ui-header{
    color: ${MagstimColor.MagstimGroupHeaderText};
    background-color: ${MagstimColor.MagstimCardHeaderBackground};
}

.header-col{
    padding-left:0px;
}

`

export default isPDA() ? withRouter(Diagnoses) : Diagnoses;